<div class="headers-wrapper">
  <attribute-item class="main-color" *ngFor="let item of data.headers"  [item]="{ key: item.headerKey, value: item.headerKey.toLowerCase() === data.customLabel?.toLowerCase() && data.customValue ? data.customValue : item.headerValue}"></attribute-item>
</div>
<div class="path-wrapper">
  <ng-container *ngIf="data.parentEntry as parent">{{ parent.displayName || parent.name }} / </ng-container>{{ data.entry.displayName || data.entry.name }}
</div>
<hr class="divider">
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-content">
    <div class="fields">
      <mat-form-field >
        <mat-label>{{ 'FAILURE_CODE' | translate}}</mat-label>
        <mat-select formControlName="failureCodes" [multiple]="data.failureMultiselect" [compareWith]="compareFailureCodes">
          <mat-option *ngFor="let item of data.failureCodeList" [value]="item">{{ item.code }}</mat-option>
          <mat-option *ngIf="data.failureCodeList.length === 0" [value]="noCodeOption">Nie dotyczy</mat-option>
        </mat-select>
        <mat-error>{{'FIELD_ERROR.FAILURE_CODE' | translate }}</mat-error>
      </mat-form-field>
      <mat-checkbox
        class="checkbox-category"
        formControlName="category"
        [checked]="form.get('category')?.value === FAILURE_CATEGORY.RED"
        (change)="form.get('category')?.setValue($event.checked ? FAILURE_CATEGORY.RED : null)">
        {{ 'RED_CATEGORY' | translate }}
      </mat-checkbox>
    </div>
    <files-list
      formControlName="photos"
      type="PHOTO"
      (uploadEvent)="uploadFile($event)"
      (deleteFileEvent)="deleteFile($event)"
      [disableUpload]="isUploadDisabled"
      [disableDelete]="false"
      [offlineMode]="!((networkStatus$ | async) ?? true)"
      [hintKey]="hintKey"
    ></files-list>
    <div *ngIf="!data.disabled" class="buttons-wrapper">
      <button *ngIf="data.failureDescription" mat-flat-button type="button" color="primary" (click)="delete()">{{ 'DEFECTS.DELETE' | translate }}</button>
      <div class="flex-grow"></div>
      <button mat-flat-button type="button" mat-dialog-close>{{ 'CANCEL' | translate }}</button>
      <button mat-flat-button color="primary" type="submit">{{ 'SAVE' | translate }}</button>
    </div>
  </div>
</form>
